import { cva as i, crv as e } from "@/styled-system/css";
const h = i({
  base: {
    display: "inline-flex",
    flexShrink: "0",
    verticalAlign: "-0.125em",
    // Magic number, but works with all textStyles
    fill: "currentcolor",
    width: "1em",
    height: "1em"
  },
  variants: {
    ...e("size", {
      sm: { width: "icon.sm", height: "icon.sm" },
      md: { width: "icon.md", height: "icon.md" },
      lg: { width: "icon.lg", height: "icon.lg" },
      xl: { width: "icon.xl", height: "icon.xl" }
    })
  }
});
export {
  h as iconRecipe
};
//# sourceMappingURL=icon.styles.js.map
